<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{}"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button size="sm" variant="outline-success" @click="showUploadForm">
            {{ $l('tips_add_file') || '上传文件' }}
          </b-button>
        </slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:fileType="{ row }">
        <span
          v-if="
            ['jpeg', 'png', 'jpg', 'gif'].includes(
              row.scmImageCode.substring(row.scmImageCode.indexOf('.') + 1)
            )
          "
          >图片</span
        >
        <span v-else>文件</span>
      </template>
      <template v-slot:defaultImgUrl="{ row }">
        <div
          v-if="
            ['jpeg', 'png', 'jpg', 'gif'].includes(
              row.scmImageCode.substring(row.scmImageCode.indexOf('.') + 1)
            )
          "
          v-viewer="{ movable: true }"
        >
          <el-image
            :src="
              row.scmImageUrl
                ? $osscdn(row.scmImageUrl)
                : '/image/static/img/nopic.jpg'
            "
            style="width:100px; height:66px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 100px; height: 66px"
              />
            </div>
          </el-image>
        </div>
        <span v-else>{{
          row.scmImageCode.substring(row.scmImageCode.indexOf('.') + 1)
        }}</span>
      </template>
      <template v-slot:uploadByImgUrl="{ row }">
        <b-avatar :src="row.memImgUrl ? $osscdn(row.memImgUrl) : ''"></b-avatar>
        <span class="ml-3">{{ row.userNameEn }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <b-button
            class="mr-2"
            v-b-tooltip.hover
            :title="$l('INDEX.btn_tips_edit') || '编辑'"
            :disabled="row.isOwner !== 'Y'"
            @click="showEdit(row)"
            variant="outline-secondary"
            size="sm"
          >
            <b-icon-pencil></b-icon-pencil>
          </b-button>
          <b-button
            class="mr-2"
            v-b-tooltip.hover
            :title="$l('INDEX.btn_tips_del') || '删除'"
            :disabled="row.isOwner !== 'Y'"
            @click="del(row.scmInfoImageCode)"
            variant="outline-secondary"
            size="sm"
          >
            <b-icon-trash></b-icon-trash>
          </b-button>
          <b-button
            v-b-tooltip.hover
            :title="$l('INDEX.btn_tips_downloada') || '下载'"
            :disabled="row.isOwner !== 'Y'"
            @click="dowloadFile(row)"
            variant="outline-secondary"
            size="sm"
          >
            <b-icon-download></b-icon-download>
          </b-button>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
    <!--编辑弹框-->
    <el-dialog
      ref="editDialog"
      :visible.sync="dialogEditFormVisible"
      :before-close="closeEditForm"
      :close-on-click-modal="false"
      width="550px"
    >
      <el-row :gutter="20">
        <el-col>
          <el-form ref="formData">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item
                  :label="$l('label_file_desc') || '文件说明'"
                  prop="scmCode"
                >
                  <el-input
                    v-model="curScmImageDesc"
                    :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                    maxlength="100"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 3 }"
                    show-word-limit
                    clearable
                    size="medium"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeEditForm">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button size="medium" type="primary" @click="updateDesc">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      ref="editDialog"
      :visible.sync="dialogUploadFormVisible"
      :before-close="closeUploadForm"
      :close-on-click-modal="false"
      :title="$l('tips_add_file') || '文件上传'"
      top="0vh"
      width="1000px"
    >
      <upload-visit-image
        v-if="dialogUploadFormVisible"
        :scmCode="scmCode"
        :visitCode="visitCode"
        @close="closeUploadForm"
        @save="uploadOk"
      >
      </upload-visit-image>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {
    UploadVisitImage: () => import('./uploadVisitImage.vue')
  },
  props: {
    scmCode: {
      default: null,
      type: String
    },
    visitCode: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      loading: false,
      dialogEditFormVisible: false,
      dialogUploadFormVisible: false,
      tableHeight: 400,
      tableData: [],
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: this.reload
        },
        zoom: true
      },
      tableColumn: [
        {
          field: 'col-opt',
          title: this.$l('INDEX.label_operation') || '操作',
          align: 'center',
          width: 150,
          fixed: 'right',
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq'
        },
        {
          field: 'fileType',
          width: 100,
          align: 'center',
          title: this.$l('label_file') || '文件类型',
          slots: { default: 'fileType' }
        },
        {
          field: 'scmImageUrl',
          width: 150,
          align: 'center',
          title: this.$l('label_image') || '图片',
          slots: { default: 'defaultImgUrl' }
        },
        {
          field: 'scmImageDesc',
          headerAlign:"center",
          minWidth: 200,
          title: this.$l('label_file_desc') || '文件说明'
        },
        {
          field: 'uploadByName',
          width: 180,
          align: 'center',
          title: this.$l('label_image_uploadby') || '上传人'
        },
        {
          field: 'createTime',
          width: 170,
          align: 'center',
          title: this.$l('label_image_createTime') || '上传时间'
        }
      ],
      curScmInfoImageCode: '',
      curScmImageDesc: ''
    }
  },
  watch: {
    visitCode: {
      handler() {
        this.loadData()
      },
      deep: true,
      immediate: true
    }
  },
  created() {},
  destroyed() {},
  methods: {
    //加载数据
    loadData() {
      this.loading = true
      let params = {
        scmCode: this.scmCode,
        visitCode: this.visitCode
      }
      this.$api
        .scmInfoImageVisitListApi(params)
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    reload() {
      this.loadData()
    },
    showEdit(row) {
      this.curScmInfoImageCode = row.scmInfoImageCode
      this.curScmImageDesc = row.scmImageDesc
      this.dialogEditFormVisible = true
    },
    updateDesc() {
      this.loading = true
      let params = {
        scmInfoImageCode: this.curScmInfoImageCode,
        scmImageDesc: this.curScmImageDesc
      }
      this.$api
        .scmInfoUpdateImageDescApi(params)
        .then(() => {
          this.loading = false
          this.dialogEditFormVisible = false
          this.reload()
        })
        .catch(() => {
          this.loading = false
        })
    },
    closeEditForm() {
      this.dialogEditFormVisible = false
    },
    del(scmInfoImageCode) {
      let msg = this.$l('INDEX.tips_question_delete') || '是否删除?'
      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning'
      }).then(() => {
        this.$api
          .scmInfoImageDelApi({ scmInfoImageCode: scmInfoImageCode })
          .then(() => {
            this.$message.success(
              this.$l('INDEX.tips_operate_ok') || '操作成功!'
            )
            this.reload()
          })
      })
    },
    // 下载文件
    dowloadFile(row) {
      window.open(this.$osscdn(row.scmImageUrl))
    },
    showUploadForm() {
      this.dialogUploadFormVisible = true
    },
    closeUploadForm() {
      this.dialogUploadFormVisible = false
    },
    uploadOk() {
      this.dialogUploadFormVisible = false
      this.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
.fabric-tree {
  height: 550px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px; /*滚动条宽度*/
  }
}
</style>
